import React from 'react'

function Banners() {
  return (
    <div>
      
    </div>
  )
}

export default Banners
